import React, { useState, useEffect } from 'react';

/**
 * Text Content Editor
 * Allows editing text content of elements
 */
export default function TextEditor({ element, onUpdate }) {
  const [text, setText] = useState('');
  const [isUpdating, setIsUpdating] = useState(false);

  useEffect(() => {
    if (element?.textContent) {
      setText(element.textContent);
    }
  }, [element]);

  const handleChange = (e) => {
    setText(e.target.value);
  };

  const handleApply = () => {
    if (!element?.dataPath || isUpdating) return;
    
    setIsUpdating(true);
    
    try {
      // Update the data property
      onUpdate(element.dataPath, text);
      console.log('Text updated:', element.dataPath, '→', text);
    } catch (error) {
      console.error('Error updating text:', error);
    } finally {
      setIsUpdating(false);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleApply();
    }
  };

  return (
    <div className="space-y-2">
      <label className="block text-xs font-medium text-gray-700">
        Text Content
      </label>
      <textarea
        value={text}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        rows={4}
        className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-none"
        placeholder="Enter text..."
        disabled={isUpdating}
      />
      <div className="flex items-center justify-between">
        <p className="text-xs text-gray-500">
          Shift+Enter for new line
        </p>
        <button
          onClick={handleApply}
          disabled={isUpdating}
          className="px-3 py-1.5 text-xs font-medium text-white bg-blue-600 rounded hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
        >
          {isUpdating ? 'Applying...' : 'Apply'}
        </button>
      </div>
      {element?.dataPath && (
        <p className="text-xs text-gray-400 font-mono">
          {element.dataPath}
        </p>
      )}
    </div>
  );
}

